export default __webpack_public_path__ + "static/media/tapicerowane10.e406d9be.jpg";